import Group from "./pages/Group.vue";
import GroupWithKeepAlive from "./pages/GroupWithKeepAlive.vue";

export default [
  {
    path: "",
    name: "home",
    component: () => import("./pages/Home.vue"),
    meta: { exact: true, title: "Tableau de bord" }
  },
  {
    path: "categories",
    component: Group,
    meta: { menu: "Métiers", children: false },
    children: [
      {
        path: "",
        name: "categories",
        component: () => import("./pages/categories/CategoriesList.vue"),
        meta: { exact: true, menu: "Liste", title: "Liste des métiers" }
      },
      {
        path: "create",
        name: "category/create",
        component: () => import("./pages/categories/CategoryCreate.vue"),
        meta: { menu: "Ajout", title: `Ajout d'un métier` }
      },
      {
        path: ":id/edit",
        name: "category/edit",
        component: () => import("./pages/categories/CategoryEdit.vue"),
        meta: { menu: "Édition", title: `Édition d'un métier` }
      }
    ]
  },
  {
    path: "collections",
    component: Group,
    meta: { menu: "Collections", children: false },
    children: [
      {
        path: "",
        name: "collections",
        component: () => import("./pages/collections/CollectionsList.vue"),
        meta: { exact: true, menu: "Liste", title: "Liste des collections" }
      },
      {
        path: "create",
        name: "collection/create",
        component: () => import("./pages/collections/CollectionCreate.vue"),
        meta: { menu: "Ajout", title: `Ajout d'une collection` }
      },
      {
        path: ":id/edit",
        name: "collection/edit",
        component: () => import("./pages/collections/CollectionEdit.vue"),
        meta: { menu: "Édition", title: `Édition d'une collection` }
      }
    ]
  },
  {
    path: "colors",
    component: Group,
    meta: { menu: "Couleurs", children: false },
    children: [
      {
        path: "",
        name: "colors",
        component: () => import("./pages/colors/Colors.vue"),
        meta: { exact: true, menu: "Liste", title: "Gestion des couleurs" }
      },
    ]
  },
  {
    path: "products",
    component: Group,
    meta: { menu: "Produits", children: false },
    children: [
      {
        path: "",
        name: "products",
        component: () => import("./pages/products/ProductsList.vue"),
        meta: { exact: true, menu: "Liste", title: "Gestion des produits" }
      },
      {
        path: "create",
        name: "product/create",
        component: () => import("./pages/products/ProductCreate.vue"),
        meta: { menu: "Ajout", title: `Ajout d'un produit` }
      },
      {
        path: ":id/edit",
        name: "product/edit",
        component: () => import("./pages/products/ProductEdit.vue"),
        meta: { menu: "Édition", title: `Édition d'un produit` }
      },
      {
        path: ":id/variants",
        name: "product/variants",
        component: () => import("./pages/products/ProductVariants.vue"),
        meta: { menu: "Déclinaisons", title: `Déclinaisons d'un produit` }
      }
    ]
  },
  // {
  //   path: "forms",
  //   component: Group,
  //   meta: { menu: "Formulaires" },
  //   children: [
  //     {
  //       path: "default",
  //       name: "forms/default",
  //       component: () => import("./pages/FormDefault.vue"),
  //       meta: { title: "Par défaut" }
  //     },
  //     {
  //       path: "alt",
  //       name: "forms/alt",
  //       component: () => import("./pages/FormAlt.vue"),
  //       meta: { title: "Alternatif" }
  //     }
  //   ]
  // }
];



// WEBPACK FOOTER //
// ./src/menu.js